import { BaseContainerModel } from "../../base-container.model";
import { bl_crm_membership_import_file_hdr_RowClass } from "../../../dbschema";

export class MembershipMasterDataContainerModel extends BaseContainerModel {
  bl_crm_membership_import_file_hdr: bl_crm_membership_import_file_hdr_RowClass =
    new bl_crm_membership_import_file_hdr_RowClass();
}
